import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {LoginService} from '../login/login.service';
import {MenuService} from '../menu/menu.service';
import {RegAlarmaService} from '../regAlarma/regAlarma.service';
import {RegAlarma} from '../regAlarma/regAlarma';
import {ROUTER_DIRECTIVES} from '@angular/router';

import * as io from "socket.io-client";
import myGlobals = require('../config');
import {DateTimeZonePipe} from "../pipes/dateTimeZonePipe";
import * as _ from "lodash";

var moment = require('moment');

@Component({
    selector: 'NavRight',
    template: require('../../app/navRight/navRight.component.html'),
    styles: [require('../../app/navRight/navRight.component.css')],
    directives: [ROUTER_DIRECTIVES],
    pipes: [DateTimeZonePipe]
})

export class NavRightComponent implements OnInit {
    showNavBar: boolean;
    menus: any;
    usuario: any;
    regAlarmas: any;
    regAlarmasRango: any;
    @Input() urlLogo: any;
    socket: any;
    @Output() alerta = new EventEmitter();
    @Output() alertaNotificaciones = new EventEmitter();

    constructor(private loginService: LoginService,
                private menuService: MenuService,
                private regAlarmaService: RegAlarmaService) {


        this.showNavBar = this.loginService.isLoggedIn() && !this.loginService.getDecodeToken().cambiarPassword;

        this.loginService.logIn.subscribe((mode) => {
            this.showNavBar = mode && !this.loginService.getDecodeToken().cambiarPassword;
            if (mode) {
                this.usuario = this.loginService.getDecodeToken();
                //Obtengo notificaciones cuando se loguea
                this.obtenerNotificaciones();
            }
        });

        this.regAlarmas = [];
        this.regAlarmasRango = [];

    }

    ngOnInit() {
        this.usuario = this.loginService.getDecodeToken();

        //Conectar al socket con configuración específica
        this.socket = io.connect(myGlobals.default.URL_MQTT_ALARMAS, { 
            path: myGlobals.default.PATH_MQTT_ALARMAS,
            transports: ['websocket', 'polling'], // Priorizar websocket
            upgrade: true,
            rememberUpgrade: true
        });

        // Debug de conexiones
        this.socket.on('connect', () => {
            console.log('Socket navRight conectado via:', this.socket.io.engine.transport.name);
            this.socket.io.engine.on('upgrade', () => {
                console.log('Socket navRight actualizado a:', this.socket.io.engine.transport.name);
            });
        });

        this.inicializarSocketAlarma();

        //Obtengo notificaciones 1era vez
        this.obtenerNotificaciones();
    }

    ngOnDestroy() {
        this.socket.disconnect();
    }

    inicializarSocketAlarma() {
        //Inicilizo socket para alarmas
        this.socket.on("alarma", function (alarma: any) {
            this.obtenerNotificaciones();
        }.bind(this));
    }

    logout() {
        $('.wrapper').toggleClass('right-toggled');
        this.loginService.logout();
    }

    toogleBar() {
        $('.wrapper').toggleClass('right-toggled');
    }

    obtenerNotificaciones() {
        if (this.showNavBar)
            this.regAlarmaService.getAllRegAlarmasActivadas().subscribe(
                regAlarmas => {
                    let _regAlarmas = new Map();
                    let _regAlarmasRango = new Map();
                    let alertaCalibracion = null;
                    regAlarmas.forEach((regAlarma) => {
                        if (!regAlarma.tipoEspecial && regAlarma.alarma_id && regAlarma.alarma_id._id && regAlarma.alarma_id.estado === true && regAlarma.nodo_id.estado === true && regAlarma.nodo_id.ubicacion_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.empresa.estado === true && regAlarma.sensor_id.estado === true) {
                            if (!_regAlarmasRango.get(regAlarma.alarma_id._id))
                                _regAlarmasRango.set(regAlarma.alarma_id._id, _.clone(regAlarma));
                            let _regAlarma = _regAlarmasRango.get(regAlarma.alarma_id._id);
                            if (!_regAlarma['color'] || !Array.isArray(_regAlarma['color'])) {
                                _regAlarma['color'] = [];
                            }
                            _regAlarma['color'].push(regAlarma['color']);
                            _regAlarma["fechaActivado"] = moment(_regAlarma["fechaActivado"]).isBefore(moment(regAlarma.fechaActivado), "minute") ? regAlarma.fechaActivado : _regAlarma["fechaActivado"];
                        }
                        if (regAlarma.tipoEspecial == "CALIBRACION" && regAlarma.sucursal_id && regAlarma.sucursal_id._id && regAlarma.sucursal_id.estado === true) {
                            if (!_regAlarmas.get(regAlarma.sucursal_id._id))
                                _regAlarmas.set(regAlarma.sucursal_id._id, _.clone(regAlarma));
                            alertaCalibracion == null ? alertaCalibracion = regAlarma.color : (alertaCalibracion == "Amarillo" ? alertaCalibracion = regAlarma.color : "");
                            let _regAlarma = _regAlarmas.get(regAlarma.sucursal_id._id);
                            if (!_regAlarma['color'] || !Array.isArray(_regAlarma['color'])) {
                                _regAlarma['color'] = [];
                            }
                            if (regAlarma['color'] == "Amarillo")
                                _regAlarma['color'].push("En 60 días");
                            else
                                _regAlarma['color'].push("En 30 días");
                            _regAlarma["fechaActivado"] = moment(_regAlarma["fechaActivado"]).isBefore(moment(regAlarma.fechaActivado), "minute") ? regAlarma.fechaActivado : _regAlarma["fechaActivado"];
                        }
                        if (regAlarma.tipoEspecial == "BATERIABAJA" && regAlarma.nodo_id.estado === true && regAlarma.nodo_id.ubicacion_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.empresa.estado === true && regAlarma.sensor_id.estado === true && (this.usuario.rol == "Tecnico" || this.usuario.rol == "Administrador")) {
                            if (!_regAlarmas.get(regAlarma.nodo_id._id))
                                _regAlarmas.set(regAlarma.nodo_id._id, _.clone(regAlarma));
                            let _regAlarma = _regAlarmas.get(regAlarma.nodo_id._id);
                            if (!_regAlarma['color'] || !Array.isArray(_regAlarma['color'])) {
                                _regAlarma['color'] = [];
                            }
                            if (regAlarma.color == "Amarillo")
                                _regAlarma['color'].push("Duración estimada");
                            else
                                _regAlarma['color'].push("Voltaje bajo");
                            _regAlarma["fechaActivado"] = moment(_regAlarma["fechaActivado"]).isBefore(moment(regAlarma.fechaActivado), "minute") ? regAlarma.fechaActivado : _regAlarma["fechaActivado"];
                        }
                        if (regAlarma.tipoEspecial == "SENSORNULL" && regAlarma.nodo_id.estado === true && regAlarma.nodo_id.ubicacion_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.empresa.estado === true && regAlarma.sensor_id.estado === true && (this.usuario.rol == "Tecnico" || this.usuario.rol == "Administrador")) {
                            if (!_regAlarmas.get(regAlarma.sensor_id._id))
                                _regAlarmas.set(regAlarma.sensor_id._id, _.clone(regAlarma));
                            let _regAlarma = _regAlarmas.get(regAlarma.sensor_id._id);
                            _regAlarma["fechaActivado"] = moment(_regAlarma["fechaActivado"]).isBefore(moment(regAlarma.fechaActivado), "minute") ? regAlarma.fechaActivado : _regAlarma["fechaActivado"];
                        }
                        if (regAlarma.tipoEspecial == "SINACTIVIDAD" && regAlarma.nodo_id.estado === true && regAlarma.nodo_id.ubicacion_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.estado === true && regAlarma.nodo_id.ubicacion_id.sucursal_id.empresa.estado === true) {
                            if (!_regAlarmas.get(regAlarma._id))
                                _regAlarmas.set(regAlarma._id, _.clone(regAlarma));
                            let _regAlarma = _regAlarmas.get(regAlarma._id);
                            _regAlarma["fechaActivado"] = moment(_regAlarma["fechaActivado"]).isBefore(moment(regAlarma.fechaActivado), "minute") ? regAlarma.fechaActivado : _regAlarma["fechaActivado"];
                        }
                    })
                    this.regAlarmasRango = Array.from(_regAlarmasRango.values());
                    this.regAlarmas = Array.from(_regAlarmas.values());
                    this.alerta.emit({alerta: alertaCalibracion});
                    this.alertaNotificaciones.emit({alertaNotificaciones: this.regAlarmasRango.length + this.regAlarmas.length});
                });

    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/navRight/navRight.component.ts